import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/draw-request/percentage-bar.scss';

export type PercentageBarColorT = 'blue' | 'lightBlue';

export type PercentageBarSegmentT = {
  color: PercentageBarColorT;
  value: number;
  key?: string;
  title?: string;
};

export type NcPercentageBarPropsT = {
  segments: PercentageBarSegmentT[];
};
export type NcPercentageBarT = React.FC<NcPercentageBarPropsT>;

export const percentageBarColorClassNames: Record<PercentageBarColorT, string> = {
  blue: 'blue',
  lightBlue: 'light-blue',
};

const SEGMENT_GAP_PX = 2;

export const NcPercentageBar: NcPercentageBarT = ({ segments }) => {
  const visibleSegments = segments.filter(({ value }) => value > 0);
  const total = visibleSegments.reduce((sum, { value }) => sum + value, 0);
  const totalGapPx = Math.max(visibleSegments.length - 1, 0) * SEGMENT_GAP_PX;

  return (
    <div aria-hidden="true" className="nc-percentage-bar" role="presentation">
      {/* eslint-disable-next-line @stylistic/object-curly-newline */}
      {total > 0 && visibleSegments.map(({ color, value, title, key }) => (
        <div
          className={mergeClassNameStrings('segment', percentageBarColorClassNames[color])}
          key={key ?? title ?? `${color}-${value}`}
          style={{ width: `calc((100% - ${totalGapPx}px) * ${value / total})` }}
          title={title}
        />
      ))}
    </div>
  );
};
